'use client';

import { showWarningToast } from '@/components/ui/sonner';
import { resolveCloudPaymentsFailMessage } from './resolveCloudPaymentsFailMessage';

export const showCloudPaymentsWarningToast = (
  reason?: string | number | null,
  paymentResult?: unknown,
): void => {
  showWarningToast(resolveCloudPaymentsFailMessage(reason, paymentResult));
};

/** Resolve toast text from return-URL code and/or payer-facing message */
export const showCloudPaymentsFailInfoToast = (failInfo: {
  errorCode?: string | number;
  message?: string;
}): void => {
  showCloudPaymentsWarningToast(
    failInfo.errorCode,
    failInfo.message ? { message: failInfo.message } : undefined,
  );
};
